export default "__VITE_ASSET__DO3t0gxf__"